<template>
    <div id="app">
        <div id="s4-workspace">
            <Header />
            <!--<div id="nav">
                <router-link to="/">Home</router-link> |
                <router-link to="/about">About</router-link>
            </div>-->
            <section class="container">
                <router-view />
            </section>
            <Footer />

            <!--<a href="#" id="btnToTop" class="btnToTop" onclick="topFunction()" style="display: none;">
                <img class="iconGotoTop" src="https://www.sec.or.th/Resource/core/img/icon_gotoTop.png" />
            </a>-->
        </div>
    </div>
</template>


<script>
    import Header from '@/components/Header.vue'
    import Footer from '@/components/Footer.vue'

    export default {
        props: {
            source: String,
        },
        components: {
            Header,
            Footer
        },
        data: () => ({

        }),
    }
</script>

<style>
    #s4-workspace {
        padding-bottom: 35px;
        background: #fff;
    }

    
    /*#app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    #nav {
        padding: 30px;
    }

        #nav a {
            font-weight: bold;
            color: #2c3e50;
        }

            #nav a.router-link-exact-active {
                color: #42b983;
            }*/
</style>
